import { create } from 'zustand';
import { useEffect } from 'react';

interface BreadcrumbState {
  /** Aktif sayfanın breadcrumb'daki son halkası için sayfa tarafından verilen ad. */
  currentLabel: string | null;
  setCurrentLabel: (label: string | null) => void;
}

const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  currentLabel: null,
  setCurrentLabel: (currentLabel) => set({ currentLabel }),
}));

export const useBreadcrumbLabelValue = () => useBreadcrumbStore((s) => s.currentLabel);

/**
 * Dinamik bir kayda açılan sayfalar (bir uygulama, bir ürün, bir şirket) için
 * breadcrumb'ın son halkasını kendi adıyla değiştirir.
 *
 * Route tablosundan türetilen etiket bu sayfalarda "Detay" demek zorunda çünkü
 * kaydın adı ancak veri geldiğinde biliniyor. Ad henüz yüklenmediyse `null`
 * geçin: jenerik etiket korunur.
 */
export function useBreadcrumbLabel(label: string | null | undefined): void {
  const setCurrentLabel = useBreadcrumbStore((s) => s.setCurrentLabel);
  useEffect(() => {
    setCurrentLabel(label ?? null);
    return () => setCurrentLabel(null);
  }, [label, setCurrentLabel]);
}
